import React, { useState, useEffect } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import authApi from "../api/authApi";

const Login = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [show, setShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [isCargo, setIsCargo] = useState(false);

  const [currentDomain, setCurrentDomain] = useState("");

  useEffect(() => {
    const domain = window.location.hostname.replace(/^www\./, "");
    setCurrentDomain(domain);

    if (domain === "gncargomovers.in") {
      setIsCargo(true);
    } else {
      setIsCargo(false);
    }
  }, []);

  // Get Banner
  const getBannerImage = () => {
    if (currentDomain === "gncargomovers.in") {
      return "https://i.postimg.cc/5N1zV0VK/banner-Cargo.jpg";
    } else if (currentDomain === "gntrailor.in") {
      return "https://i.postimg.cc/VL1wvxzs/1.jpg";
    } else if (currentDomain === "gnroadlines.in") {
      return "https://i.ibb.co/pvpD274G/GNRoadlinesbanner.png";
    }
  };

  // Get Logo
  const getLogo = () => {
    if (currentDomain === "gncargomovers.in") {
      return "https://i.ibb.co/MyY2Hds3/gncm-final-logo-2.jpg";
    } else if (currentDomain === "gntrailor.in") {
      return "https://i.postimg.cc/NMkfwyX3/094A7281.jpg";
    } else if (currentDomain === "gnroadlines.in") {
      return "https://i.ibb.co/Jj1JshKz/gnroadline-Logo-removebg-preview.png";
    }
  };

  // Get Slogan
  const getSlogan = () => {
    if (currentDomain === "gncargomovers.in") {
      return "Bharosa Har Load Ka, Safar Har Road Ka!";
    } else if (currentDomain === "gnroadlines.in") {
      return "Har Raasta, Har Manzil Ka Saathi!";
    } else {
      return "";
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await authApi.login(credentials.email, credentials.password);
    if (result.success) {
      localStorage.setItem("token", result.authToken);
      localStorage.setItem("username", result.username);
      let data = await authApi.fetchMyImage();
      if (data)
        localStorage.setItem("myimage", window.URL.createObjectURL(data));
      else
        localStorage.setItem(
          "myimage",
          "https://www.w3schools.com/howto/img_avatar.png"
        );
      navigate("/dashboard");
    } else {
      setShow(true);
      setErrorMessage(result.errors);
    }
  };

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  return (
    <Container>
      <Row className="login-form p-3 mt-5">
        <Col lg={6}>
          <img
            src={getBannerImage()}
            style={{
              display: "flex",
              alignItems: "center",
              height: currentDomain === "gnroadlines.in" ? "361px" : "250px",
              marginTop: "100px",
              width: currentDomain === "gnroadlines.in" ? "102%" : "100%",

            }}
            alt="Banner"
          />
        </Col>
        <Col lg={6} className="login-section">
          <div className="p-5">
            <Form onSubmit={handleSubmit}>
              <div className="mb-2">
                <center>
                  <img
                    style={{ width: "220px", height: "180px" }}
                    className="pt-6"
                    src={getLogo()}
                    alt="Logo"
                  />
                  <p style={{ alignItems: "center" }}>{getSlogan()}</p>
                </center>
              </div>
              <div className="p-5">
                <div className="mt-2 text-center mb-4">
                  <i className="fa-solid fa-lock-open fa-2xl"></i>
                  <h3 className="mt-2">Login</h3>
                </div>
                <Alert variant="danger" show={show}>
                  {errorMessage}
                </Alert>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    onChange={handleChange}
                    placeholder="Enter email"
                    value={credentials.email}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    onChange={handleChange}
                    placeholder="Password"
                    value={credentials.password}
                  />
                </Form.Group>

                <Button variant="primary" type="submit">
                  Login
                </Button>
                {/* {currentDomain !== "gnroadlines.in" && (
                  <Button
                    variant="success"
                    className="mx-3"
                    onClick={() => {
                      window.location.href = isCargo
                        ? "https://gntrailor.in"
                        : "https://gncargomovers.in";
                    }}
                  >
                    {isCargo
                      ? "Switch to GN Trailer and Transport"
                      : "Switch To GN Cargo"}
                  </Button>
                )} */}
                {/* Show switch button based on domain */}
                {currentDomain === "gnroadlines.in" ? (
                  <Button
                    variant="success"
                    className="mx-3"
                    onClick={() => navigate("/logingnroadlines")}
                  >
                    Switch to GN RoadLines & Transways
                  </Button>
                ) : (
                  <Button
                    variant="success"
                    className="mx-3"
                    onClick={() => {
                      window.location.href = isCargo
                        ? "https://gntrailor.in"
                        : "https://gncargomovers.in";
                    }}
                  >
                    {isCargo
                      ? "Switch to GN Trailer and Transport"
                      : "Switch To GN Cargo"}
                  </Button>
                )}
              </div>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
